interface BirthdayParts {
  year?: string;
  month?: string;
  day?: string;
}

const padTwoDigits = (value?: string) => (value || '').padStart(2, '0');

export const formatBirthdayForApi = ({ year = '', month = '', day = '' }: BirthdayParts) => {
  return `${year}-${padTwoDigits(month)}-${padTwoDigits(day)}`;
};
